import { defineStore } from 'pinia';
import { useBaseStore } from '../shared/baseStore';
import { container } from 'inversify-props';
import { ILineService, ILineServiceId } from './ILineService';
import { Line } from './Line';

export const useLinesStore = defineStore('lines', {
    state: () => ({
        lines: new Array<Line>()
    }),
    actions: {
        getLineByNumber(number: string) {
            return this.lines.find(x => x.number === number);
        },
        async fetchLines(calendarDay: string) {
            const baseStore = useBaseStore();
            const linesService = container.get<ILineService>(ILineServiceId);

            try {
                baseStore.setIsLoading(true);

                const lines = await linesService.getLines(calendarDay);

                this.lines = lines;
                baseStore.setIsLoading(false);
            } catch {
                this.lines = new Array<Line>();
                baseStore.setIsLoading(false);
            }
        }
    }
});
